import {
  Component,
  AfterContentInit,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import dayjs from 'dayjs';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import { NgClass } from '@angular/common';

dayjs.extend(isoWeek);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear); // dependency for isoWeeksInYear

/**
 * @deprecated Do not add new instances of this component. Use 'ag1-week-range' instead.
 */
@Component({
  selector: 'ag-week-picker-popup',
  templateUrl: './week-picker-popup.component.html',
  styleUrls: ['./week-picker-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class WeekPickerPopupComponent implements AfterContentInit {
  constructor() {}

  @ViewChild('weekSelector', { static: true })
  weekSelectorRef: ElementRef;

  @ViewChild('yearSelector', { static: true })
  yearSelectorRef: ElementRef;

  weeks: Array<number> = null;
  years: Array<number> = null;
  showYears = true;

  week = 0;
  year = 0;
  itemHeight = 30;
  width = 300;
  height = 200;

  weekChange: EventEmitter<number> = new EventEmitter();
  yearChange: EventEmitter<number> = new EventEmitter();

  ngAfterContentInit(): void {
    const isoWeeksInYear = dayjs().year(this.year).isoWeeksInYear();

    // display number of weeks in selected year OR ensure 53 if showYears is false
    this.weeks = Array<number>(this.showYears ? isoWeeksInYear : 53)
      .fill(0)
      .map((_, i) => i + 1);
    // display 15 years, going 5 back and 9 forward
    this.years = Array<number>(15)
      .fill(0)
      .map((_, i) => i + (new Date().getFullYear() - 5));

    // set week to 52 if 53 was selected but year selection changed to one with only 52 weeks
    if (this.week == 53 && isoWeeksInYear != 53 && this.showYears) {
      this.week = 52;
      this.weekChange.emit(this.week);
    }

    setTimeout(() => {
      if (!this.week && !this.year) {
        this.week = dayjs().isoWeek();
        this.year = dayjs().isoWeekYear();
        this.weekChange.emit(this.week);
        this.yearChange.emit(this.year);
      }
      this.weekSelectorRef.nativeElement.scrollTop =
        (this.week - 2) * this.itemHeight;
      this.yearSelectorRef.nativeElement.scrollTop =
        (this.year - (new Date().getFullYear() - 4)) * this.itemHeight;
    });
  }

  setWeek(event: Event, week) {
    event.preventDefault();
    event.stopPropagation();
    this.week = week;
    this.weekChange.emit(this.week);
    this.weekSelectorRef.nativeElement.scrollTop =
      (this.week - 2) * this.itemHeight;
  }

  setYear(event: Event, year) {
    event.preventDefault();
    event.stopPropagation();
    this.year = year;
    this.yearChange.emit(this.year);
    this.ngAfterContentInit(); // to re-run max week num calc for selected year & re-run 'scrollTop' calc
  }
}
